import TextField from "@material-ui/core/TextField/TextField";
import React from "react";
import Icon from "@material-ui/core/Icon";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  iconInputContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& > .material-icons": {
      marginRight: theme.spacing(2),
    },
  },
}));

const IconTextField = ({ icon, form, field, error, ...rest }) => {
  const classes = useStyles();

  // If Formik form:
  if (form) {
    // We reset error as we want to use the one from the formik:
    error = "";
    if (form && form.errors[field.name] && form.touched[field.name]) {
      console.log("Error", form.errors, form.touched);
      error = form.errors[field.name];
    }
  }

  return (
    <div className={classes.iconInputContainer}>
      <Icon>{icon}</Icon>
      <TextField
        margin="normal"
        variant="outlined"
        error={error}
        helperText={error}
        {...field}
        {...rest}
      />
    </div>
  );
};

export default IconTextField;
